<template>
    <div
        :class="{
            'form-group': true,
            'has-error': error,
            'has-warning': warning,
        }"
    >
        <label
            :for="id"
            v-if="label"
            :class="{
                'col-sm-2': horizontal,
                'control-label': true,
            }"
        >
            {{ label }}
            <span v-if="isRequired" class="text-danger">*</span>
        </label>
        <div
            v-if="horizontal"
            :class="{
                'col-sm-10': label,
                'col-sm-12': !label,
            }"
        >
            <slot></slot>
            <span v-if="warning" class="help-block">
                <i class="icon fa fa-warning"></i>
                {{ warning }}
            </span>
            <span v-if="error" class="help-block">{{ error }}</span>
            <span v-if="helpText" class="help-block">{{ helpText }}</span>
        </div>
        <template v-else>
            <slot></slot>
            <span v-if="warning" class="help-block">
                <i class="icon fa fa-warning"></i>
                {{ warning }}
            </span>
            <span v-if="error" class="help-block">{{ error }}</span>
            <span v-if="helpText" class="help-block">{{ helpText }}</span>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: false,
            default: null,
        },
        horizontal: {
            type: Boolean,
            required: false,
            default: true,
        },
        id: {
            type: String,
            required: false,
            default: null,
        },
        isRequired: {
            type: Boolean,
            required: false,
            default: false,
        },
        error: {
            type: String,
            required: false,
            default: null,
        },
        warning: {
            type: String,
            required: false,
            default: null,
        },
        helpText: {
            type: String,
            required: false,
            default: null,
        },
    },
};
</script>
